export default __webpack_public_path__ + "static/media/ic-dataops.e97524c3.svg";